import maplibregl from 'maplibre-gl'

/** Coordinate pair as delivered by the backend: [lat, lng]. */
export type LatLngTuple = [number, number]

export interface RoutePoint {
  lat: number | string
  lng: number | string

  [key: string]: unknown
}

/** Coordinate pair in MapLibre order: [lng, lat]. */
export type LngLat = [number, number]

export interface LineFeatureCollection {
  type: 'FeatureCollection'
  features: Array<{
    type: 'Feature'
    properties: Record<string, unknown>
    geometry: {type: 'LineString'; coordinates: LngLat[]}
  }>
}

// MapLibre expects [lng, lat]; the rest of the app works in [lat, lng].
export function tupleToLngLat(point: LatLngTuple): LngLat {
  return [point[1], point[0]]
}

export function pointToLngLat(point: RoutePoint): LngLat {
  return [Number(point.lng), Number(point.lat)]
}

export function tuplesToLngLat(route: LatLngTuple[]): LngLat[] {
  return route.map(tupleToLngLat)
}

export function pointsToLngLat(route: RoutePoint[]): LngLat[] {
  return route.map(pointToLngLat)
}

export function lineFeatureCollection(coordinates: LngLat[]): LineFeatureCollection {
  return {
    type: 'FeatureCollection',
    features: [{type: 'Feature', properties: {}, geometry: {type: 'LineString', coordinates}}]
  }
}

export function emptyFeatureCollection(): LineFeatureCollection {
  return {type: 'FeatureCollection', features: []}
}

export function boundsFromLngLat(coordinates: LngLat[]): maplibregl.LngLatBounds | null {
  if (!coordinates.length) {
    return null
  }

  return coordinates.reduce(
    (bounds, coord) => bounds.extend(coord),
    new maplibregl.LngLatBounds(coordinates[0], coordinates[0])
  )
}
